import { environment } from "../../environments/environment";

export class ApiRoutes {
    static readonly baseUrl = environment.api_endpoint;

    static readonly user = `user`;
    static readonly city = `city`;
    static readonly address = `address`;
    static readonly event = `event`;
    static readonly role = 'role';
    static readonly feature = 'feature';
    static readonly org = 'org';
    static readonly templates = 'templates';
    static readonly notify = 'templates/notify';
    static readonly packages = 'packages';
    static readonly vehicles = 'vehicles';
    static readonly trips = 'trips';
    static readonly tripComment = 'trips/comment';
    static readonly tripInvoice = 'trips/invoice';
    static readonly tripDutySlip = 'trips/dutySlip';
    static readonly tripGenerateInvoiceNumber = 'trips/invoice/generate';
    static readonly orgTypes = 'orgTypes';
    static readonly orgTypesChildren = `${ApiRoutes.orgTypes}/children`;
    static readonly orgTypesParents = `${ApiRoutes.orgTypes}/parents`;
    static readonly byId = (route: string, id: any) => `${route}/${id}`;
    static readonly uploadCSV = "uploadCSVFile";

    // Auth Related
    static readonly auth = `auth`;
    static readonly login = `${ApiRoutes.auth}/login`;
    static readonly sendOtp = `${ApiRoutes.auth}/send_otp`;
    static readonly forgotPassword = `${ApiRoutes.auth}/forget_password`;
    static readonly resetPassword = `${ApiRoutes.auth}/reset_password`;
    static readonly refreshUser = `${ApiRoutes.auth}/refresh`;

    static readonly bookings = `bookings`;
    static readonly singleBookings = `bookings/singleBooking`;
};